module.exports = __webpack_public_path__ + "img/orange.514d09fb.png";